import { trigger, state, style, transition, animate, sequence } from '@angular/animations';

export const shakeTrashCanAnimation = trigger('shakeTrashCan', [
  state('normal', style({ transform: 'scale(1)' })),

  state('sizeUp', style({ transform: 'scale(2)' })),

  state('sizeNormal', style({ transform: 'scale(1)' })),

  state('shakeLeft', style({ transform: 'rotate(-10deg)' })),
  state('shakeRight', style({ transform: 'rotate(10deg)' })),

  transition('normal => sizeUp', animate('1s ease-out')), // Faster pop effect

  transition('sizeUp => sizeNormal', animate('1s ease-in')),
  /** shakes 3 times */
  transition('sizeNormal => shakeLeft', sequence([
    animate('.1s ease-in-out', style({ transform: 'rotate(10deg)' })),
    animate('.1s ease-in-out', style({ transform: 'rotate(-10deg)' })),
    animate('.1s ease-in-out', style({ transform: 'rotate(10deg)' })),
    animate('.1s ease-in-out', style({ transform: 'rotate(-10deg)' })),
    animate('.1s ease-in-out', style({ transform: 'rotate(10deg)' })),
    animate('.1s ease-in-out', style({ transform: 'rotate(0deg)' })) // Stop shaking
  ]))
]);
